import PropTypes from "prop-types";
import { withTranslation } from "../../translation";
import styles from "./CategoryPreviewHeader.css";

const CategoryPreviewHeader = ({
  categoryName,
  categoryUrl,
  formatTranslation,
}) => (
  <div className={styles.header}>
    <div className={styles.title}>
      <div className={styles.titleLineOne}>
        {formatTranslation("plp_curatedcategories_carousel_title_discover")}
      </div>
      <span className={styles.titleLineTwo}>{categoryName}</span>
    </div>
    <a className={styles.viewAllButton} href={categoryUrl}>
      {formatTranslation("plp_curatedcategories_carousel_cta_view_all")}
    </a>
  </div>
);

CategoryPreviewHeader.propTypes = {
  categoryName: PropTypes.string.isRequired,
  categoryUrl: PropTypes.string.isRequired,
  formatTranslation: PropTypes.func.isRequired,
};

export default withTranslation(CategoryPreviewHeader);
